import SettingsKey from 'app/profile/settings/utils/settingsTypes';
import { useSettingValue } from 'common/hooks/useSettingValue';
import { customMenuPropsRight } from 'common/utils/menuProps';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getUser } from 'redux/slices/authSlice';
import { getGroupsByIds } from 'redux/slices/groupSlice';
// import { fetchUnitsAction } from 'redux/slices/unitSlice';
import SelectAssets from 'app/calendarV4/iCalendar/filters/SelectAssets';
import SelectGroups from 'app/calendarV4/iCalendar/filters/SelectGroups';
import SelectUsers from 'app/calendarV4/iCalendar/filters/SelectUsers';
import SelectServiceType from './SelectServiceType';

const ServicesFilter = () => {
    const user = useSelector(getUser);
    const enableGroups = useSettingValue(SettingsKey.ENABLE_USER_GROUPS);
    const showGroupFilter =
        enableGroups && (!user.userGroupId || user.managedGroups?.length > 1) && user.role !== 'creator';
    const groups = useSelector(getGroupsByIds);
    const [params, setSearchParams] = useSearchParams();
    const groupId = params.get('group') || 'all';
    const assetId = params.get('asset') || 'all';
    const agentId = params.get('agent') || 'all';

    const onSubmit = async (newValue, type) => {
        let updatedSearchParams = new URLSearchParams(params.toString());
        updatedSearchParams.delete('page');
        if (newValue) {
            updatedSearchParams.set(type, newValue.target.value);
            setSearchParams(updatedSearchParams.toString());
        } else {
            updatedSearchParams.delete(type);
            setSearchParams(updatedSearchParams.toString());
        }
    };

    return (
        <>
            <SelectServiceType
                customMenuProps={customMenuPropsRight}
                onSubmit={onSubmit}
                fullWidth={false}
                size="smallWidth"
            />

            {showGroupFilter ? (
                <SelectGroups
                    customMenuProps={customMenuPropsRight}
                    onSubmit={onSubmit}
                    id={groupId}
                    selectAll={true}
                    selectedById={groups?.[0]}
                    fullWidth={false}
                    size="smallWidth"
                />
            ) : null}
            <SelectUsers
                customMenuProps={customMenuPropsRight}
                onSubmit={onSubmit}
                id={agentId}
                selectAll={true}
                fullWidth={false}
                size="smallWidth"
                groupParamId={groupId}
            />
            <SelectAssets
                customMenuProps={customMenuPropsRight}
                id={assetId}
                selectAll={true}
                onSubmit={onSubmit}
                size="smallWidth"
                fullWidth={false}
            />
        </>
    );
};

export default ServicesFilter;
